<template>
    <section>
        <h2 class="body-small text-ink-muted mb-3">
            {{ subjectName ? `How ${subjectName} sees themselves, vs. how others see them` : "How you see yourself, vs. how others see you" }}
        </h2>
        <BaseCard padding="lg">
            <!-- Legend order mirrors ScoreRow's bar order (self on top, others below)
                 so the swatches read top-to-bottom the same as the bars. -->
            <div class="flex items-center gap-5 mb-5 body-small">
                <span class="flex items-center gap-2">
                    <span class="w-3 h-3 rounded-sm bg-valence-pink-600"></span>
                    {{ subjectName ? `${subjectName}'s self rating` : "Your self rating" }}
                </span>
                <span class="flex items-center gap-2"><span class="w-3 h-3 rounded-sm bg-valence-light-blue-400"></span> Rated by others</span>
            </div>
            <div class="flex flex-col gap-6">
                <ScoreRow
                    v-for="q in questions"
                    :key="q.question_id"
                    :label="q.title"
                    :avg="q.all_avg"
                    :self-avg="q.self_score"
                    :max-score="maxScoreFor(q)"
                    :show-self-comparison="true" />
            </div>
        </BaseCard>
    </section>
</template>

<script setup lang="ts">
import ScoreRow from "~vue/AssessmentResults/ScoreRow.vue";
import BaseCard from "~vue/components/BaseCard.vue";

import type { PerQuestion } from "./types";

interface Props {
    questions: PerQuestion[];
    // Set when someone other than the subject (a team lead) is viewing;
    // switches the copy to third person.
    subjectName?: string;
}

defineProps<Props>();

function maxScoreFor(q: PerQuestion): number {
    return q.max_score ?? q.distribution.length;
}
</script>
